import enableDisableInboxRuleRequest from 'owa-service/lib/factory/enableDisableInboxRuleRequest';
import setInboxAndSweepRulesRequest from 'owa-service/lib/factory/setInboxAndSweepRulesRequest';
import setInboxAndSweepRulesOperation from 'owa-service/lib/operation/setInboxAndSweepRulesOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
/**
 * Helper method that creates the SetInboxAndSweepRulesRequest body
 * @param inboxRuleIds the list of inbox ruleIds in order
 * @param inboxRules the map that contains the inbox rule objects
 * @return EnableInboxRuleRequest
 */
function createRequestBody(inboxRuleIds, inboxRules) {
    var enableDisableRequests = [];
    inboxRuleIds.forEach(function (inboxRuleId) {
        var request = enableDisableInboxRuleRequest({
            Header: getJsonRequestHeader(),
            Identity: inboxRules.get(inboxRuleId).Identity,
            IsEnabled: inboxRules.get(inboxRuleId).Enabled,
        });
        enableDisableRequests.push(request);
    });
    return setInboxAndSweepRulesRequest({
        Header: getJsonRequestHeader(),
        EnableDisableInboxRules: enableDisableRequests,
    });
}
/**
 * Enable inbox rule service
 * @param inboxRule the inbox rule
 * @return EnableInboxRuleResponse
 */
export default function setInboxAndSweepRulesService(inboxRuleIds, inboxRules) {
    var requestBody = createRequestBody(inboxRuleIds, inboxRules);
    return setInboxAndSweepRulesOperation(requestBody);
}
//# sourceMappingURL=setInboxAndSweepRulesService.js.map